<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </b-button>
        </div>
      </div>
      <b-row>
        <b-col lg="7">
            <b-input-group>
            <b-input-group-prepend>
              <label>Product Code</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.prodcode"
              placeholder="Product Code"
              :state="!$v.model.prodcode.$error"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Product Name</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.prodname"
              placeholder="Product Name"
              :state="!$v.model.prodname.$error"
            ></b-form-input>
          </b-input-group>
              <b-input-group>
            <b-input-group-prepend>
              <label>Product Description</label>
            </b-input-group-prepend>
            <b-form-textarea
              id="textarea"
              v-model="model.description"
              placeholder="Please enter prodcut description"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend>
              <label>Menu Image</label>
            </b-input-group-prepend>
            <image-uploader
              :debug="0"
              :maxWidth="160"
              :maxHeight="100"
              :maxSize="25.60"
              :quality="1"
              outputFormat="verbose"
              :className="['fileInput', { 'fileInput--loaded' : imgUploader.hasImage }]"
              :capture="false"
              accept="image/*"
              doNotResize="['gif', 'svg']"
              @input="setImage"
              ref="imgloader1"
            >
              <label for="fileInput" slot="upload-label">
                <figure>
                  <img
                    :src="model.menuimg"
                    v-if="imgUploader.hasImage"
                    class="border border-primary"
                    width="350"
                    height="350"
                  />
                </figure>
                <span class="upload-caption">
                  <i class="fa fa-file-image-o"></i>
                  {{ imgUploader.hasImage ? 'Replace' : 'Upload' }}
                </span>
              </label>
            </image-uploader>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-for="field in formfields" :key="field.key" :cols="field.col">
          <b-input-group >
              <b-input-group-prepend><label>{{field.label}}</label></b-input-group-prepend>
            <b-form-input v-model="model[field.key]" v-if="!field.type"
              :state="field.validations?!$v.model[field.key].$error:true"
              :placeholder="field.placeholder?field.placeholder:'Please enter '+(field.label).toLowerCase()"
            ></b-form-input>
            <b-form-select
              v-if="field.type=='selected'"
              v-model="model[field.key]"
              :state="field.validations?!$v.model[field.key].$error:true"
              :options="field.options"
            ></b-form-select>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="justify-content-center mb-2 mt-2">
        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
          <i class="fa fa-save"></i> Save
        </button>
        <b-button class="btn btn-primary mr-1" @click.stop="close()">
          <i class="fa fa-close"></i> {{$t('close')}}
        </b-button>
      </b-row>
    </b-card>
    <!-- <b-modal v-model="lkuOutletShow" size="lg" :hide-footer="true" title="List of Outlet/Branch" :centered="true">
            <lku-outlet @click="onSelectLkuOutlet"></lku-outlet>
        </b-modal>        
        <b-modal v-model="lkuMenucategoryShow" size="lg" :hide-footer="true" title="Resto Menu Categories" :centered="true">
            <lku-menucategory @click="onSelectlkuMenucategory"></lku-menucategory>
        </b-modal>       
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
    </b-modal>-->
  </div>
</template>
<style lang="scss">
// label{
//   width: 200px !important;
// }
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 130px;
    }
  }
}
.form-group {
  margin-bottom: 2px;
  .input-group {
    padding-bottom: 0;
  }
}
.row-details-form {
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}
.fileInput {
  display: none;
}
.img-preview {
  display: none;
}
.upload-caption {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #c8ced3;
  margin: 0 10px;
  color: #23282c;
  background-color: #c8ced3;
}
.upload-caption:hover {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #c8ced3;
  margin: 0 10px;
  color: #23282c;
  background-color: silver;
}
</style> 
<script>
import moment from "moment";
import myNumber from "../../components/my-number";
import { VueEditor } from "vue2-editor";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
import ImageUploader from "vue-image-upload-resize";
import produkkredit from "../../apis/produkkredit";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { myNumber, ImageUploader, VueEditor },
  mixins: [validationMixin],
  validations: {
    model: {
      prodcode: { required },
      prodname: { required },
      prodtype: { required },
      model_pinjaman: { required },
      prodofferingcode: { required },
      prodofferingname: { required }
      // salesacc: { required },
    },
    outletObj: {
      outletid: { required },
      hargajual: { required, minValue: minValue(1) }
    }
  },
  data() {
    return {
      model: {
        prodcode: "",
        prodname: "",
        prodofferingcode: "",
        prodofferingname: "",
        prodtype: null,
        model_pinjaman: null,
        description: ""
      },
      optProdType: [
        { value: null, text: "Please select an option", disabled: true },
        { value: "CF", text: "Cash Flow" }
        // { value: "PRK", text: "Pinjaman Rekening Koran" }
      ],
      optmodel_pinjaman: [
        { value: null, text: "Please select an option", disabled: true },
        { value: "PAB", text: "Pinjaman Angsuran Bulanan" },
        { value: "PRK", text: "Pinjaman Rekening Koran" }
      ],
      lkuCoaShow: false,
      lkuCoaCaller: "adv",
      tahun: (this.$store.state.user.tglaktif || "").substring(0, 4),
      saveEnabled: true,
      imgUploader: { hasImage: false, image: null },

      lkuOutletShow: false,
      lkuMenucategoryShow: false,
      currency: [{ value: "IDR", text: "IDR" }],
      outletObj: {
        outletid: "",
        hargajual: 0,
        kenapajak: ""
      },
      restooutlet: {
        list: [],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "outletname",
            label: "Outlet Name"
          },
          {
            key: "provinsi",
            label: "Province",
            sortable: true
          },
          {
            key: "hargajual",
            label: "Price",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "kenapajak",
            label: "TAX Applied",
            thStyle: "width:110px",
            sortable: true
          },
          {
            key: "action",
            label: "action",
            thClass: "text-center",
            tdClass: "text-center"
          }
        ],
        page: 1,
        limit: 6,
        total: 0
      }
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidOutletObj() {
      this.$v.outletObj.$touch();
      return this.$v.outletObj.$invalid;
    },
     formfields(){
      const fields=[
          {
              key: "prodofferingcode",
              label: "Product Offering Code",
              placeholder:'Enter product offering code',
              col:6,
              validation:true
          },
          {
              key: "prodofferingname",
              label: "Product Offering Name",
              placeholder:'Enter product offering name',
              col:6,validation:true
          },
          {
              key: "prodtype",
              label: "Product Type",
              type:'selected',options:this.optProdType,
              col:6
          },
          {
              key: "model_pinjaman",
              label: "Product Model",
              type:'selected',options:this.optmodel_pinjaman,
              col:6
          },
          {
              key: "ar_dueNo",
              label: "AR Due COA",
              col:6
          },
          {
              key: "ar_dueNm",
              label: "AR Due COA Name",
              col:6
          },
          {
              key: "arnot_dueNo",
              label: "AR Undue COA",
              col:6
          },
          {
              key: "arnot_dueNm",
              label: "AR Undue COA Name",
              col:6
          },
          {
              key: "UCI_No",
              label: "UCI COA",
              col:6
          },
          {
              key: "UCI_Nm",
              label: "UCI COA Name",
              col:6
          },
          {
              key: "ECI_No",
              label: "ECI COA",
              col:6
          },
          {
              key: "ECI_Nm",
              label: "ECI COA Name",
              col:6
          },
          {
              key: "AR_NA_No",
              label: "AR NA COA",
              col:6
          },
          {
              key: "AR_NA_Nm",
              label: "AR NA COA Name",
              col:6
          },
          {
              key: "UCI_NA_No",
              label: "UCI NA COA",
              col:6
          },
          {
              key: "UCI_NA_Nm",
              label: "UCI NA COA Name",
              col:6
          },   
          {
              key: "Beban_diskon_No",
              label: "Beban Diskon COA No",
              col:6
          },
          {
              key: "Beban_diskon_Nm",
              label: "Beban Diskon COA Name",
              col:6
          },        
        ];
      return fields;
    },
  },
  created: async function() {
    if (this.$route.params.productkey) {
      toastr.info("Loading Product Detail, please wait");
      try {
        const productkey = this.$route.params.productkey;
        const data = await produkkredit.detail(productkey);
        for (var key in data) {
          this.model[key] = data[key];
        }
        console.log('model',this.model)
        this.$forceUpdate();
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "Error Info", 10000);
      }
    }
  },
  methods: {
    setImage: function(output) {
      this.imgUploader.hasImage = true;
      this.imgUploader.image = output;
      this.model.menuimg = this.imgUploader.image.dataUrl;
      console.log("image output", output);
    },
    save: async function() {
      if (this.invalidModel) {
        console.log("validation  : ", this.$v.model);
        console.log("model : ", this.model);
        toastr.error("Please fill the form correctly.", "Error Info");
      } else {
        try {
          const data = {};
          for (var key in this.model) {
            data[key] = this.model[key];
          }
          await produkkredit.save(data);
          toastr.success('Save data successfully', "Info", 10000);
          this.close();
        } catch (error) {
          if (error.message) {
            toastr.error(error.message, "Error Info", 10000);
          } else {
            toastr.error(JSON.stringify(error), "Error Info", 10000);
          }
        }
      }
    },
    close() {
      router.push({ name: "loan.master-product" });
    }
  }
};
</script>